<div [ngClass]="controller.getClassObject(pageComponent, ['page'])">

  <div class="elements">

    <div class="text">
      @for (element of textElements; track element) {
        @if (element.type == 'header') {
          <h1 id="question-text" class="header">
            {{element.value}}
          </h1>
        }
        @if (element.type == 'p') {
          <p [ngClass]="controller.getClassObject(element, [])">{{element.value}}</p>
        }
      }
    </div>

    @for (element of otherElements; track element) {
      @if (element.type == 'reflection-image') {
        <div class="image" style="background: url('../../../assets/img/reflection.png');"></div>
      }
      @if (element.type == 'likert') {
        <div>
          <app-likert [scale]="element.properties.scale"
            [value] = "value"
            [leftLabel]="element.properties.leftLabel"
            [rightLabel]="element.properties.rightLabel"
            (valueChange)="handleValueChange($event)">
          </app-likert>
        </div>
      }
      <div class="question-area">
        @if (element.type == 'textarea') {
          <textarea data-testid="feedback-text" aria-labelledby="question-text"
            (blur)="handleValueChange($event.target.value)"
            #textEntry
          [placeholder]="element.properties && element.properties.placeholder ? element.properties.placeholder: 'Please enter your thoughts to continue' ">{{value}}</textarea>
        }
        @if (element.type == 'email') {
          <input data-testid="feedback-email" type="email"
            (blur)="handleValueChange($event.target.value)"
            aria-labelledby="question-text"
            [value]="value"
            #textEntry
            [placeholder]="element.properties && element.properties.placeholder ? element.properties.placeholder: 'Please enter your email'"
            />
        }
      </div>
      @if (element.type == 'dropdown') {
        <app-dropdown
          class="dropdown"
          [value]="value"
          (valueChange)="handleValueChange($event)"
          [options]="dropdownOptions"
          [placeholder]="element.properties && element.properties.placeholder ? element.properties.placeholder: 'Please select an option' "
        ></app-dropdown>
      }
      @if (!this.optional && this.displayRequired) {
        <div class="required">
          {{this.requiredText}}
        </div>
      }
      @if (!this.displayRequired) {
        <div class="required" style="visibility:hidden;">
          {{this.requiredText}}
        </div>
      }
    }
  </div>

</div>

<div class="buttons">
  <ng-container>
    <button data-testid="feedback-previous" (click)="onPrev()" class="btn btn-outline-primary btn-outline">Previous</button>
  </ng-container>

  <ng-container>
    <button data-testid="feedback-next" (click)="onNext()" [ngClass]="getNextClass()">Next</button>
  </ng-container>


</div>


<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
